const atob = require('atob');
const btoa = require('btoa');

const stripEquals = val => val.replace(/%3D/g, '');

// eslint-disable-next-line consistent-return
export const encodeString = val => {
  try {
    return btoa(val);
  } catch (err) {
    // String is probably not in a format that btoa() can encode it
  }
};

// eslint-disable-next-line consistent-return
export const decodeString = val => {
  try {
    return atob(stripEquals(val));
  } catch (err) {
    // String is probably not in a format that atob() can decode it
  }
};

export const encodeAndStringify = val => val ? encodeString(JSON.stringify(val)) : '';
export const decodeAndParse = val => val ? JSON.parse(decodeString(val)) : {};
